import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const InclusionsExclusions = ({ inclusions, exclusions }) => {
  const [activeTab, setActiveTab] = useState("included");

  const tabs = [
    {
      id: "included",
      label: "What's Included",
      icon: "Check",
      count: inclusions?.length,
    },
    {
      id: "excluded",
      label: "What's Excluded",
      icon: "X",
      count: exclusions?.length,
    },
  ];

  return (
    <div className="bg-[#fafaf7] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="section-heading text-foreground mb-3">
            Package <span className="text-secondary">Details</span>
          </h2>
          <div className="w-16 h-1 bg-secondary rounded-full mx-auto mb-4" />
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Transparent pricing with comprehensive inclusions. Know exactly
            what's covered in your trek package and what additional expenses to
            plan for.
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="bg-white rounded-xl p-1.5 border border-border/50 shadow-sm inline-flex">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  activeTab === tab?.id
                    ? "bg-primary text-white shadow-sm"
                    : "text-text-secondary hover:text-foreground hover:bg-muted/50"
                }`}
              >
                <Icon
                  name={tab?.icon}
                  size={16}
                  className={activeTab === tab?.id ? "text-white" : ""}
                />
                <span>{tab?.label}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  activeTab === tab?.id
                    ? "bg-white/20 text-white"
                    : "bg-primary/10 text-primary"
                }`}>
                  {tab?.count}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          {activeTab === "included" && (
            <div className="animate-fade-in">
              <div className="grid md:grid-cols-2 gap-6">
                {inclusions?.map((category, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 border border-border/50 hover:shadow-sm transition-shadow duration-200"
                  >
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-11 h-11 rounded-xl bg-success/10 flex items-center justify-center">
                        <Icon
                          name={category?.icon}
                          size={20}
                          className="text-success"
                        />
                      </div>
                      <h3 className="font-headline font-semibold text-foreground text-lg">
                        {category?.title}
                      </h3>
                    </div>

                    <ul className="space-y-3">
                      {category?.items?.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Icon
                              name="Check"
                              size={12}
                              className="text-success"
                            />
                          </div>
                          <span className="text-text-secondary text-sm leading-relaxed">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "excluded" && (
            <div className="animate-fade-in">
              <div className="grid md:grid-cols-2 gap-6">
                {exclusions?.map((category, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 border border-border/50 hover:shadow-sm transition-shadow duration-200"
                  >
                    <div className="flex items-center gap-3 mb-5">
                      <div className="w-11 h-11 rounded-xl bg-error/10 flex items-center justify-center">
                        <Icon
                          name={category?.icon}
                          size={20}
                          className="text-error"
                        />
                      </div>
                      <h3 className="font-headline font-semibold text-foreground text-lg">
                        {category?.title}
                      </h3>
                    </div>

                    <ul className="space-y-3">
                      {category?.items?.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Icon
                              name="X"
                              size={12}
                              className="text-error"
                            />
                          </div>
                          <span className="text-text-secondary text-sm leading-relaxed">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InclusionsExclusions;
